import { magic } from '@gig/magic-sdk';

function signUpCoreX(params) {
    return magic.transport.request('corex/register-user', params);
}
function verifyEmailCoreX(userId, verificationCode) {
    return magic.transport.request('corex/verify-user-profile', {
        userId: userId,
        type: 'email',
        code: verificationCode,
    });
}
function verifyPhoneCoreX(userId, verificationCode) {
    return magic.transport.request('corex/verify-user-profile', {
        userId: userId,
        type: 'phone',
        code: verificationCode,
    });
}

export { signUpCoreX, verifyEmailCoreX, verifyPhoneCoreX };
